import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';
// ========================= PrimeNG =========================
import { providePrimeNG } from 'primeng/config';
import { MyTheme } from './theme.settings';
// ========================= Transloco =========================
import { TranslocoHttpLoader } from '../transloco-loader';
import { provideTransloco } from '@jsverse/transloco';
import { provideTranslocoLocale } from '@jsverse/transloco-locale';
// ========================= NgRx Store =========================
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { globalReducer } from './store/global.reducer';

export const BACKEND_HOSTNAME = window.location.hostname === 'localhost' ? 'http://localhost:3000/api' : `https://serkanyarar.dev/api`;

export const sharedConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(),
    provideClientHydration(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    providePrimeNG({
      theme: {
        preset: MyTheme,
        options: {
          colorScheme: 'light',
          darkModeSelector: '.s-dark'
        }
      }
    }),
    // ========================= Transloco =========================
    provideTransloco({
      loader: TranslocoHttpLoader,
      config: {
        availableLangs: [
          { id: 'en', label: 'English' },
          { id: 'de', label: 'Deutsch' },
          { id: 'tr', label: 'Türkce' }
        ],
        reRenderOnLangChange: true,
        fallbackLang: 'de',
        defaultLang: 'en',
        missingHandler: {
          useFallbackTranslation: false
        }
      }
    }),
    provideTranslocoLocale({
      langToLocaleMapping: {
        en: 'en-US',
        de: 'de-DE',
        tr: 'tr-TR'
      }
    }),
    // ========================= NgRx Store =========================
    provideStore({ global: globalReducer }),
    provideStoreDevtools()
  ]
};
